import { StyleSheet, TouchableOpacity } from 'react-native';

import { spacing } from '../../../theme';
import ArrowRight from './arrow-right.svg';

interface Props {
	currentIndex: number;
	itemsCount: number;
	onNextPress: () => void;
	onPreviousPress: () => void;
}

export const PaginationControls = ({
	currentIndex,
	itemsCount,
	onNextPress,
	onPreviousPress,
}: Props) => {
	return (
		<>
			{currentIndex > 0 && (
				<TouchableOpacity onPress={onPreviousPress} style={[styles.controlButton, styles.previous]}>
					<ArrowRight />
				</TouchableOpacity>
			)}

			{currentIndex < itemsCount - 1 && (
				<TouchableOpacity onPress={onNextPress} style={[styles.controlButton, styles.next]}>
					<ArrowRight />
				</TouchableOpacity>
			)}
		</>
	);
};

const styles = StyleSheet.create({
	controlButton: {
		position: 'absolute',
		paddingHorizontal: spacing(4),
		justifyContent: 'center',
		height: '100%',
	},
	previous: {
		transform: [{ rotate: '180deg' }],
	},
	next: {
		right: 0,
	},
});
